/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ContractorType;

(function (ContractorType) {
  ContractorType["INDEPENDENT_CONTRACTOR"] = "independent_contractor";
  ContractorType["PAYE"] = "paye";
})(ContractorType || (ContractorType = {}));